const { io } = require("socket.io-client");

const parsedTelefone = process.env.MIX_TELEFONE === "true";
let connection = { on: function () { }, emit: function () { } };
if (parsedTelefone) {
	connection = io(`${location.protocol}//${location.hostname}:3006/`, {
		query: {
			"userId": user.getId()
		}
	});
}

connection.on('reloadApp', () => {
	window.location.reload();
});

module.exports = {
	connection
}
